import {
  OPEN_POPUP,
  CLOSE_POPUP,
  CLEAR_POPUP
} from '../constants/ActionTypes'

const initialState = {
  display: false,
  name: null,
  content: null
}

export default function user(state = initialState, action) {
  switch (action.type) {
    case OPEN_POPUP:
      return {
        display: true,
        name: action.name,
        content: action.content
      }
    case CLOSE_POPUP:
      return {
        display: false
      }
    case CLEAR_POPUP:
      return {
        display: false,
        name: null,
        content: null
      }
    default:
      return state
  }
}